import type { RouteLocationRaw, RouteRecordRaw } from "vue-router";
import {customAsyncComponent} from "@/functions/customAsyncComponent";
import {LOCALE_CATEGORIES} from "@/assets/locales/categories.ts";

export function getSignInRouteRecord():RouteRecordRaw{
  return {
    name: 'sign_in',
    path: '/sign-in',
    component: customAsyncComponent(async () => import('./views/SignInView.vue')),
    meta: {
      noAuth: true,
      localeCategories: [
        LOCALE_CATEGORIES.SIGN_IN,
        LOCALE_CATEGORIES.SIGN_UP,
        LOCALE_CATEGORIES.ERRORS,
      ]
    },
  }
}

export function getSignInRouteLocation():RouteLocationRaw{
  return { name: 'sign_in' }
}